const getCurrentLocalization = () => {
  const locale =
    window.drupalSettings?.sgnaGeolocation?.siteLocale?.country || '';

  return locale.toLowerCase();
};

const localesMap = {
  US: 'us',
  Canada: 'ca',
};

const locale = getCurrentLocalization();

export const excludedLocale =
  locale === localesMap.US ? localesMap.Canada : localesMap.US;

const getCurrentCountryAbbr = () => {
  const { country } = window.drupalSettings?.sgnaGeolocation?.siteLocale;

  return country || '';
};

const getCurrentLanguageCode = () => {
  const { language } = window.drupalSettings?.sgnaGeolocation?.siteLocale;

  return language || '';
};

const createLocalizationAlgoliaQuery = () => {
  if (!locale) {
    return '';
  }

  return `(NOT field_localization:${excludedLocale})`;
};

const createLocalizedAlgoliaDocsQuery = () => {
  if (!locale) {
    return '';
  }
  return `(NOT media_field_region_top_abbreviation:${excludedLocale})`;
};

const getCurrentCountryName = () => {
  const { country } = window.drupalSettings?.sgnaGeolocation?.siteLocale;
  const { countryFullNames } = window.drupalSettings?.sgnaGeolocation;

  if (country && countryFullNames) {
    return countryFullNames[country.toLowerCase()];
  }
  return '';
};

export const { supportedLocales, languageFullNames, domains } =
  window.drupalSettings?.sgnaGeolocation || {};

const getCurrentLanguageName = () => {
  const { language } = window.drupalSettings?.sgnaGeolocation?.siteLocale;

  if (language && languageFullNames) {
    return languageFullNames[language];
  }
  return '';
};

const createCanadaEcomedesAlgoliaQuery = () =>
  locale === localesMap.Canada ? '(NOT  media_field_remote_type:Ecomedes)' : '';

export {
  localesMap,
  getCurrentLocalization,
  getCurrentCountryAbbr,
  getCurrentLanguageName,
  getCurrentLanguageCode,
  createLocalizationAlgoliaQuery,
  createLocalizedAlgoliaDocsQuery,
  getCurrentCountryName,
  createCanadaEcomedesAlgoliaQuery,
};
